import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { useSelector, useDispatch } from 'react-redux';
import MuiAlert from '@mui/material/Alert';
import { setAlertMessageSnackbarOpen } from '../store/feedback';


export const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SnackbarAlert = () => {
  const dispatch = useDispatch();
  const {snackbarOpen, snackbarMessage,snackbarMessageSeverity}=useSelector((state)=>state.feedbackStore)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    const alert={snackbarOpen:false,snackbarMessage:"",snackbarMessageSeverity:""}
    dispatch(setAlertMessageSnackbarOpen(false));
   
  };

  return (
    <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleClose} >
      <Alert onClose={handleClose} severity={`${snackbarMessageSeverity}`} sx={{ width: '100%',boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px"}}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
  )
}